module.exports = __webpack_public_path__ + "img/hakuna_xmas_bg01.833e63c8.jpg";